import { fetchUtils, type Options } from "ra-core";

import { getToken } from "./tokenStorage";

/**
 * Base URL of the PHP API.
 *
 * In development Vite proxies `/api` to http://127.0.0.1:8081 (see
 * vite.config.ts); in production `api/` sits next to the built frontend, so
 * the relative default works there too. Override with `VITE_API_URL`.
 */
export const API_URL: string = (
  (import.meta.env.VITE_API_URL as string | undefined) ?? "/api"
).replace(/\/+$/, "");

/**
 * `fetchUtils.fetchJson` with the bearer token of the logged-in user.
 *
 * `fetchJson` already turns a non-2xx response into a ra-core `HttpError`
 * carrying the `{ message }` of the API, so callers only have to look at
 * `error.status` when they want to react to a specific code.
 */
export const httpClient = (
  url: string,
  options: Options = {},
): ReturnType<typeof fetchUtils.fetchJson> => {
  // Keep the headers the caller set (ra-data-simple-rest sends `Range` on
  // lists and `Content-Type: text/plain` on deletes).
  const headers = new Headers(
    options.headers ?? { Accept: "application/json" },
  );
  headers.set("X-Requested-With", "XMLHttpRequest");
  const token = getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetchUtils.fetchJson(url, { ...options, headers });
};
